import { isV2CompoundId } from '@frontend/sports/betting-offer/feature/model';

import { buildIPriceFromBasePrice, emptyPrice } from '../../core/group-pick-helpers';
import { BetslipBetBuilderPick } from '../../core/picks/betslip-bet-builder-pick';
import { BetslipGroupPick } from '../../core/picks/betslip-group-pick';
import { BetslipPick } from '../../core/picks/betslip-pick';
import { GroupPickId, PickId } from '../../core/picks/pick-id';

export function getBetBuilderPick(id: PickId, picks: BetslipPick[], groupMustExist?: boolean): BetslipBetBuilderPick | BetslipGroupPick | null {
    if (GroupPickId.isId(id)) {
        const group = picks.find((p) => p.id.toString() === id.toString());
        if (!group) {
            const legs = picks.filter((p) => p.groupInfo?.groupId === id.groupInfo.groupId);
            if (legs.length === 1) {
                return new BetslipGroupPick({
                    groupInfo: id.groupInfo,
                    sgpId: '',
                    picks: legs,
                    price: buildIPriceFromBasePrice(emptyPrice()),
                    legsInfo: [],
                    isSuspended: false,
                });
            }
            if (legs.length > 1 && !!groupMustExist) {
                return null;
            }
        }

        return group as BetslipGroupPick;
    }

    return getBetBuilderPickForEvent(picks, id.fixtureId);
}

export function getLegsCount(pick: BetslipBetBuilderPick | BetslipGroupPick | null): number {
    if (!!pick && (BetslipBetBuilderPick.isPick(pick) || BetslipGroupPick.isPick(pick))) {
        return pick.getLegs().length;
    }

    return 0;
}

export function getBetBuilderPickForEvent(picks: BetslipPick[], eventId: string): BetslipBetBuilderPick | null {
    const betBuilderPicks = picks.filter((pick) => BetslipBetBuilderPick.isEntainUiBetBuilderPick(pick)) as BetslipBetBuilderPick[];
    const betBuilderPick = betBuilderPicks.find((pick) => (isV2CompoundId(eventId) ? pick.id.fixtureId : pick.eventId) === eventId);

    return betBuilderPick ? betBuilderPick : null;
}
